export const VAT_RATE = 0.19;

export const PACKAGES = [
  {
    id: 'starter',
    name: 'Starter',
    price: 390,
    audience: 'Für Gastronomie, Handwerk, Einzelhandel und Dienstleister, die im Markt sichtbar werden wollen.',
    zone: 'Mall & Vorkasse oder Eingang & Frische',
    spot: '10 Sekunden, 1 Platz je Schleife',
    contacts: 'rund 70.000 pro Monat',
    cpm: 'etwa 5,60 € je 1.000 Sichtkontakte',
  },
  {
    id: 'klassik',
    name: 'Klassik',
    price: 790,
    audience: 'Für Autohäuser, Fitnessstudios, Immobilien und Bildungsanbieter mit klarem Angebot.',
    zone: 'Kassenzone + Mall & Vorkasse',
    spot: '10 Sekunden, 1 Platz je Schleife',
    contacts: 'rund 150.000 pro Monat',
    cpm: 'etwa 5,30 € je 1.000 Sichtkontakte',
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 1490,
    badge: 'Meiste Reichweite',
    audience: 'Für Banken, Versicherungen, Kliniken und Tourismus – mit Exklusivität in Ihrer Branche.',
    zone: 'Alle fünf Zonen, alle 50 Bildschirme',
    spot: '15 Sekunden, 1 Platz je Schleife',
    extras: 'Inklusive Branchenexklusivität, Zeitfenster nach Wunsch',
    contacts: 'rund 300.000 pro Monat',
    cpm: 'etwa 5,00 € je 1.000 Sichtkontakte',
  },
  {
    id: 'kassen-fokus',
    name: 'Kassen-Fokus',
    price: 890,
    audience: 'Für alle, die die Wartezeit nutzen wollen: Nur die Kassenzone, dafür maximale Wiederholung.',
    zone: 'Kassenzone',
    spot: '10 Sekunden, 1 Platz je Schleife',
    contacts: 'rund 190.000 pro Monat',
    cpm: 'etwa 4,70 € je 1.000 Sichtkontakte',
  },
  {
    id: 'mall-partner',
    name: 'Mall-Partner',
    price: 590,
    audience: 'Für Mieter der Ladenstraße und Gastronomie im Haus: Dauerpräsenz dort, wo Ihre Gäste vorbeigehen.',
    zone: 'Mall & Vorkasse',
    spot: '10 Sekunden, 2 Plätze je Schleife',
    contacts: 'rund 120.000 pro Monat',
    cpm: 'etwa 4,90 € je 1.000 Sichtkontakte',
  },
];

export const CAMPAIGNS = [
  {
    id: 'brand-impact',
    name: 'Brand Impact',
    price: 2900,
    desc: 'Neuprodukt oder Aktion schnell bekannt machen: hohe Frequenz auf allen Bildschirmen.',
    duration: '2 Wochen',
    zones: 'Alle fünf Zonen, 2 Plätze je Schleife',
    spot: '10 Sekunden',
    contacts: 'rund 1,0 Mio. Sichtkontakte',
  },
  {
    id: 'closed-loop',
    name: 'Closed Loop',
    price: 4900,
    badge: 'Mit Zweitplatzierung',
    desc: 'Bildschirm und Zweitplatzierung vor dem Regal – Ihr Produkt ist sichtbar, wo gegriffen wird.',
    duration: '4 Wochen',
    zones: 'Alle fünf Zonen, 2 Plätze je Schleife',
    extras: 'Zweitplatzierung vor dem Regal, abgestimmt mit dem Warengeschäft',
    contacts: 'rund 2,0 Mio. Sichtkontakte',
  },
  {
    id: 'verkostungs-booster',
    name: 'Verkostungs-Booster',
    price: 3500,
    desc: 'Probieren lassen und gleichzeitig auf allen Bildschirmen dazu einladen – mit Coupon zum Nachkaufen.',
    duration: '2 Wochen + 1 Verkostungstag',
    zones: 'Alle fünf Zonen',
    extras: 'Verkostungsfläche, QR-Coupon zum Nachkaufen',
    contacts: 'rund 1,0 Mio. Sichtkontakte',
  },
  {
    id: 'local-hero',
    name: 'Local Hero',
    price: 1200,
    desc: 'Für Winzer, Brauereien und Erzeuger aus der Region: Ihre Geschichte dort, wo genossen wird.',
    duration: '4 Wochen',
    zones: 'Bedientheken + Eingang & Frische',
    spot: '15 Sekunden, 1 Platz je Schleife',
    contacts: 'rund 600.000 Sichtkontakte',
  },
];

export const DURATIONS = [
  { months: 1, label: '1 Monat', note: 'Listenpreis', discount: 0 },
  { months: 3, label: '3 Monate', note: '5 % Nachlass', discount: 0.05 },
  { months: 6, label: '6 Monate', note: '10 % Nachlass', discount: 0.1 },
  { months: 12, label: '12 Monate', note: '15 % Nachlass', discount: 0.15 },
];

export const SPOT_OPTIONS = [
  { id: 'none', name: 'Keine – wir liefern den fertigen Spot', price: 0, note: '' },
  { id: 'standard', name: 'Spotproduktion Standard', price: 490, note: 'Animierter Spot aus Ihren Bildern, Logo und Text, 10 Sekunden, inkl. 2 Korrekturen' },
  { id: 'plus', name: 'Spotproduktion Plus', price: 990, note: 'Motion-Design mit Bildwelt und Sprecher-Text als Einblendung, 15 Sekunden' },
  { id: 'film', name: 'Spotproduktion Film', price: 1500, note: 'Dreh bei Ihnen vor Ort, Schnitt und drei Fassungen für Saison oder Aktionen' },
];

export const fmt = (n) =>
  n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

const r2 = (x) => Math.round(x * 100) / 100;

export function computePrice(s) {
  const lines = [];
  if (s.kind === 'beratung') {
    lines.push({ label: 'Beratung vor Ort (ca. 30 Minuten im Markt)', amount: 0 });
    return { lines, monthly: 0, oneTime: 0, totalNetto: 0, vat: 0, brutto: 0 };
  }

  if (s.kind === 'campaign') {
    const c = CAMPAIGNS.find((x) => x.id === s.selectionId);
    if (!c) return { lines, monthly: 0, oneTime: 0, totalNetto: 0, vat: 0, brutto: 0 };
    lines.push({ label: `Kampagne ${c.name} · ${c.duration}`, amount: c.price });
    const spot = SPOT_OPTIONS.find((x) => x.id === s.spotProduction);
    if (spot && spot.price > 0) lines.push({ label: spot.name + ' (einmalig)', amount: spot.price });
    const total = r2(lines.reduce((a, l) => a + l.amount, 0));
    return { lines, monthly: 0, oneTime: total, totalNetto: total, vat: r2(total * VAT_RATE), brutto: r2(total * (1 + VAT_RATE)) };
  }

  const p = PACKAGES.find((x) => x.id === s.selectionId);
  if (!p) return { lines, monthly: 0, oneTime: 0, totalNetto: 0, vat: 0, brutto: 0 };
  const months = s.founder ? 12 : s.months || 1;
  const discount = s.founder ? 0.2 : (DURATIONS.find((d) => d.months === months)?.discount || 0);
  let pct = 0;
  const pctParts = [];
  if (s.exclusivity && p.id !== 'premium' && !s.founder) { pct += 0.3; pctParts.push('Branchenexklusivität +30 %'); }
  if (s.timeWindow && p.id !== 'premium') { pct += 0.15; pctParts.push('Zeitfenster +15 %'); }

  const base = p.price * months;
  const pctExtra = r2(base * pct);
  const sponsoring = s.sponsoring ? 990 * months : 0;
  const spot = SPOT_OPTIONS.find((x) => x.id === s.spotProduction);
  let oneTime = spot ? spot.price : 0;
  if (s.founder && s.spotProduction === 'standard') oneTime = 0;

  lines.push({ label: `${p.name} · ${months} ${months === 1 ? 'Monat' : 'Monate'}`, amount: base });
  if (pctExtra > 0) lines.push({ label: pctParts.join(' · '), amount: pctExtra });
  if (sponsoring > 0) lines.push({ label: `Sponsoring Rezept der Woche · ${months} Monate`, amount: sponsoring });
  const discountAmount = r2((base + pctExtra) * discount);
  if (discountAmount > 0) {
    lines.push({ label: s.founder ? 'Gründungspartner-Nachlass 20 %' : `Laufzeit-Nachlass ${Math.round(discount * 100)} %`, amount: -discountAmount });
  }
  if (spot && spot.price > 0) {
    lines.push({
      label: s.founder && spot.id === 'standard' ? 'Spotproduktion Standard (im Gründungspartner enthalten)' : spot.name + ' (einmalig)',
      amount: s.founder && spot.id === 'standard' ? 0 : spot.price,
    });
  }

  const totalNetto = r2((base + pctExtra) * (1 - discount) + sponsoring + oneTime);
  const monthly = r2(((base + pctExtra) * (1 - discount) + sponsoring) / months);
  return { lines, monthly, oneTime, totalNetto, vat: r2(totalNetto * VAT_RATE), brutto: r2(totalNetto * (1 + VAT_RATE)) };
}
